import { registerControllers } from 'stimulus-vite-helpers'
import { stimulus } from '~/init'
import PasswordVisibility from '@stimulus-components/password-visibility'

stimulus.register('password-visibility', PasswordVisibility)

const controllers = import.meta.glob('./**/*_controller.js', { eager: true })
registerControllers(stimulus, controllers)
